// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var englishTranslation = {
    translations: {
        welcome: "Hello <br/> <strong>World</strong>",
        404: {
            title: "Page not found",
            subtitle: "The page you are looking for does not exist",
        },
        homeScreen: {
            step1: "Step 1: Import your ballot",
            description1: "To continue, please import the encrypted ballot data  provided in the Voting Portal:",
            importBallotHelpDialog: {
                title: "Information: Import your ballot",
                ok: "OK",
                content: "To continue, please import the encrypted ballot data  provided in the Voting Portal.",
            },
            step2: "Step 2: Insert your ballot ID",
            description2: "Please type in the ballot ID provided in the Voting Portal:",
            ballotIdHelpDialog: {
                title: "Information: Your ballot ID",
                ok: "OK",
                content: "Please type in the ballot ID provided in the Voting Portal.",
            },
            startButton: "Browse file",
            dragDropOption: "Or drag and drop it here",
            importErrorDescription: "There was a problem importing the auditable ballot. Did you choose  the right file?",
            importErrorMoreInfo: "More info",
            importErrorTitle: "Error",
            ciphertextErrorTitle: "Ballot verification failed",
            ciphertextErrorDescription: "The ciphertext in this auditable ballot is not the encryption of the plaintext and randomness it contains. The ballot cannot be trusted.",
            useSampleLink: "Use a sample ballot",
            nextButton: "Next",
            ballotIdLabel: "Ballot ID",
            ballotIdPlaceholder: "Type in your Ballot ID",
            fileUploaded: "Uploaded",
        },
        confirmationScreen: {
            ballotIdTitle: "Ballot ID",
            ballotIdDescription: "Bellow the system shows the Ballot ID of the decodes ballot, and the one generated by the verifier",
            ballotIdError: "Does’t match the decoded ballot ID",
            decodedBallotId: "Decoded Ballot Id",
            decodedBallotIdHelpDialog: {
                title: "Information: Decoded Ballot Id",
                ok: "OK",
                content: "This is the Ballot ID read from decoding the Auditable Ballot file you provided.",
            },
            yourBallotId: "The Ballot Id you provided",
            userBallotIdHelpDialog: {
                title: "Information: The Ballot Id you provided",
                ok: "OK",
                content: "This is the Ballot Id you typed in the previous step and that you collected from the Voting Booth.",
            },
            backButton: "Back",
            printButton: "Print",
            finishButton: "Verified",
            verifySelectionsTitle: "Verify your ballot selections",
            verifySelectionsDescription: "The following ballot selections have been decoded from the ballot you imported. Please review them and ensure that they match the selections you made in the Voting Portal.  If your selections don't match, please contact the election authorities...",
            verifySelectionsHelpDialog: {
                title: "Information: Verify your ballot selections",
                ok: "OK",
                content: "The following ballot selections have been decoded from the ballot you imported. Please review them and ensure that they match the selections you made in the Voting Portal.  If your selections don't match, please contact the election authorities...",
            },
            markedInvalid: "Ballot explicitly marked invalid",
            points: "({{points}} Points)",
            contestNotFound: "Contest not found: {{contestId}}",
            declineToVote: "Declined to vote",
            blankBallot: "Blank ballot",
            acclamationDescription: "This contest was decided by acclamation. Its candidates are elected without a vote, so no option can be selected and no vote is recorded for it.",
        },
        footer: {
            poweredBy: "Powered by <1></1>",
        },
        errors: {
            encoding: {
                notEnoughChoices: "Not enough choices to decode",
                writeInChoiceOutOfRange: "Write-in choice out of range: {{index}}",
                writeInNotEndInZero: "Write in doesn't end on 0",
                bytesToUtf8Conversion: "Error converting write-in from bytes to UTF-8 string: {{errorMessage}}",
                ballotTooLarge: "Ballot larger than expected",
            },
            implicit: {
                selectedMax: "Number of selected choices {{numSelected}} is more than the maximum {{max}}",
                selectedMin: "Number of selected choices {{numSelected}} is less than the minimum {{min}}",
            },
            explicit: {
                notAllowed: "Ballot marked explicitly invalid but question doesn't allow it",
            },
        },
    },
};
export default englishTranslation;
